enum FetchDataPolicy {
  cacheAndNetwork = "cache-and-network",
  networkOnly = "network-only",
}

enum ErrorPolicy {
  all = "all",
  ignore = "ignore",
}

export { FetchDataPolicy, ErrorPolicy };
